export default "__VITE_ASSET__D_AM_muq__"